import { z } from "zod";

// Single-step signup per the landed contract (POST /api/users/signup/ takes the
// password directly): name + email + password + confirm in one form.
export const signupSchema = z
  .object({
    firstName: z.string().trim().min(1, "Enter your first name"),
    lastName: z.string().trim().min(1, "Enter your last name"),
    email: z.string().trim().min(1, "Enter your email").email("Enter a valid email address"),
    password: z.string().min(8, "Use at least 8 characters"),
    confirm: z.string().min(1, "Re-enter your password"),
  })
  .refine((v) => v.password === v.confirm, {
    message: "Passwords don't match.",
    path: ["confirm"],
  });

export type SignupValues = z.infer<typeof signupSchema>;
